import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import { allFilterPages, generateOrderDashboardParams } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

import { getOrderDashboardFilterOptionSearch } from '@services/orderDashboard';

const CommercialInvoiceNumber = ({ filterPageName, showFilter }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [search, setSearch] = useState('');
	const debounceSearch = useDebouncedCallback((text) => setSearch(text), 500);
	const orderDashboardFilterFields = useSelector((store) => store.filterFieldStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.MY_ORDER]: dependentFilterList?.commercialInvoiceList
	};
	const onFetchData = async () => {
		let responseData = filterData[filterPageName] || [];
		responseData = responseData
			?.filter((item) => item.name)
			?.map((item) => {
				return { id: item.name, name: item.name, ...item };
			});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = async (e) => {
		debounceSearch(e.target.value);
	};

	useEffect(() => {
		if (showFilter) {
			(async () => {
				let orderQuery = generateOrderDashboardParams(orderDashboardFilterFields);
				const data = await getOrderDashboardFilterOptionSearch(
					`?filterType=COMMERCIAL_INVOICE&search=${search}${orderQuery}`
				);
				let responseData = data
					?.filter((item) => item.name)
					?.map((item) => {
						return { id: item.name, name: item.name, ...item };
					});
				setData(responseData);
			})();
		}
	}, [search, showFilter]);

	return (
		<>
			<FilterName type="COMMERCIAL_INVOICE_NUMBER" />
			<Checkbox data={data} type="COMMERCIAL_INVOICE_NUMBER" handleSearch={handleSearch} />
		</>
	);
};

export default CommercialInvoiceNumber;
